import * as React from 'react'
//import { InvoiceReport } from '../../services/API/InvoiceReports'
import Accordion from '../Accordion/StyledAccordion';
import i18n from '../../i18n';
import { IsUserSinfra, ReadFriendlyNumber } from '../../lib/utils';
import { HandleActionModal, InternalInvoiceReport } from './editTypes';
import { Button, Dropdown, Stack } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataService } from '../../services/DataService';
import { InvoiceReport } from '../../services/API/InvoiceReports';
import { Department } from '../../services/API/Departments';
import { DisplayHistory } from './DisplayHistory';
import { Customer } from '../../services/API/Customer';

interface InfoProps{
    data:InternalInvoiceReport/*InvoiceReport*/;
    handleChange:(e:React.ChangeEvent<HTMLTextAreaElement> | number,key:keyof Pick<InternalInvoiceReport,'departmentId' | 'comment'>,item?:InternalInvoiceReport) => void;
    handleActionModal:HandleActionModal;
    editHistory:any;
    customers:Customer[];
    departments?:Department[];
    department?:Department;
    editModeActive:boolean;
  }
const InfoBar = (props:InfoProps) => {
  
    const renderInfo = () => {
        const cellStyle : React.CSSProperties = {
          paddingLeft:8
        }   
         const statusObj = DataService.InvoiceReports.GetStatus(props.data as InvoiceReport);   
        return (
          <>
          <div style={{display:'flex',flexDirection:'row', flexWrap: "wrap"}}>
           <Stack style={{ justifyContent: "", flexWrap: "wrap" }}>
         {typeof props.editHistory !== 'undefined' && props.editHistory.length > 0 &&
           <DisplayHistory editModeActive={props.editModeActive} handleActionModal={props.handleActionModal} data={props.editHistory} customers={props.customers}/>
         }   
         
         <div style={{display:'flex',flexDirection:'row',width:'inherit',position:'relative',flex:'wrap'}}>  
        
          <div style={{display:'flex',flexDirection:'column'}}>
          <div style={{ fontSize: 18}}>{props.data?.supplierName+`(${props.data?.supplierOrgId})`}{` - `}<FontAwesomeIcon icon={statusObj.icon} color={statusObj.color} style={{marginRight:"5px"}}/>{statusObj.statusText}
          </div>
         {props.data?.reporter.includes('@') ? <a style={{width:'fit-content'}} href={`mailto:${props.data?.reporter}`}>{props.data?.reporter}</a>:<div style={{ fontSize: 14, fontStyle: "italic", color: "#878686"}}>{props.data?.reporter}</div>} 
          <div style={{ fontSize: 14, fontStyle: "italic", color: "#878686"}}>{props.data?.reportDate.toLocaleDateString()}</div>
          </div>
          {/*DENNA LÄGGS TILL NÄR DET FINNS ETT STÖD FÖR DET <Button
    style={{
      width: 'fit-content',
      height: 'fit-content',
      position: 'absolute',
      top: 0,
      right: 0,
    }}
    disabled={!IsUserSinfra()}
    className="button button-danger"
    onClick={() => props.handleActionModal('DELETEREPORT', true, -1)}
  >
    <FontAwesomeIcon
      icon="warning"
      style={{ marginRight: 4 }}
    />
    Makulera
  </Button> */}
              </div>   
        </Stack>
       
        </div>
          <Accordion open title={i18n.t("invoiceReportList.invoiceReportModal.info").toString()} titleStyle={{fontSize: "1.1rem", margin: 0}} style={{padding: "0px 10px 0px"}} contentStyle={{paddingLeft: 4}}>
          <table 
          >
            <tbody>
              <tr>
                <td>{i18n.t("invoiceReportList.invoiceReportModal.comment")} </td>
                <td style={cellStyle}><textarea  cols={30} style={{resize:'both'}} value={props.data.comment} onChange={(e) => 
                 props.handleChange(e,'comment',props.data)}/></td>
              </tr>
              <tr>
                <td>{i18n.t("invoiceReportList.invoiceReportModal.noOfInvoices")} </td>
                <td style={cellStyle}>{props.data.noOfInvoices}</td>
              </tr>
              <tr>
                <td>{i18n.t("invoiceReportList.invoiceReportModal.noOfInvoicesImported")} </td>
                <td style={cellStyle}>{props.data.noOfInvoicesImported}</td>
              </tr>
              <tr>
                <td>{i18n.t("invoiceReportList.invoiceReportModal.totalSumExclMoms")} </td>
                <td style={cellStyle}>{ReadFriendlyNumber(props.data.totalSumExclMoms ?? 0)}</td>
              </tr>
              <tr>
                <td>{i18n.t("invoiceReportList.invoiceReportModal.totalSumExclMomsImported")} </td>
                <td style={cellStyle}>{ReadFriendlyNumber(props.data.totalSumExclMomsImported ?? 0 )}</td>
              </tr>
              <tr>
                <td>{i18n.t("invoiceReportList.invoiceReportModal.noOfWarnings")} </td>
                <td style={cellStyle}>{props.data.noOfWarnings}</td>
              </tr>
             {typeof props.data?.departmentId !== 'undefined' &&
             props.data?.departmentId !== null &&
              <tr>
              {typeof props?.departments !== 'undefined' && 
              <>
              <td>
              {i18n.t('departmentList.singular')}
              <FontAwesomeIcon style={{marginLeft:'4px'}} icon='building'/>
            </td>
                  <td style={cellStyle}>
                <Dropdown>
                <Dropdown.Toggle bsPrefix='newStyleToggle'>
                  {props?.department?.department ?? 'Välj ny avdelning för rapporten'}
                </Dropdown.Toggle>
                <Dropdown.Menu>                  
                {props.departments?.map((x:Department) => {
                      return <Dropdown.Item key={x.id} id={`${x}`} onClick={() => {
                        if(x.id !== props.data?.departmentId){
                          props.handleActionModal('CHANGEDEPARTMENT',true,x.id)
                        }
                      }}>{x.department }</Dropdown.Item>
                    })}
                </Dropdown.Menu>
                </Dropdown>
                </td>
                </>
              }
              
            </tr>
             }
              
            </tbody>
          <p></p>
          </table>
          </Accordion>
          </>
        )
      }
      return(
        <>
        {renderInfo()}
        </>
      )  
}
export{
    InfoBar
}